import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { FaSearch } from "react-icons/fa";
import { useEffect, useState, useContext } from "react";
import { adminContext } from "../../../context/admincontext";
import { GetAllAdminUsers, searchUsers } from "../../../services/adminServices";
import { Link } from "react-router-dom";
import { downloadUrl } from "../../../confing/confing";
import { useNavigate } from "react-router-dom";
import user from "../../../assets/user.png"

const AdminUsers = () => {
  const [list, setList] = useState([]);
  const [page, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const { setPage } = useContext(adminContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("لیست کاربران");
        const { data } = await GetAllAdminUsers(10, page);
        console.log(data);
        setList(data.result);
        setTotalPage(data.totalPage);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [page]);

  const searchUser = async () => {
    const search = document.getElementById("search").value;
    if (search) {
      const { data } = await searchUsers(10, page, search);
      setList(data.result);
      setTotalPage(data.totalPage);
    } else {
      const { data } = await GetAllAdminUsers(10, page);
      setList(data.result);
      setTotalPage(data.totalPage);
    }
  };

  const pagechanging = (number) => {
    setPageNumber(number);
    // console.log("zahra")
  };
  const nextpage = () => {
    setPageNumber(page + 1);
  };
  const prevpage = () => {
    setPageNumber(page - 1);
  };
  return (
    <div style={{ paddingTop: "10px" }}>
      <Header />
      <div className="d-flex content-box">
        <Menu />
        <div className="w-100 me-lg-3 ms-lg-5">
          <div className="row g-0 align-items-center my-requstes-filter-box p-2">
            <div className="mb-2 mb-md-0 p-1 col-11 ">
              <input
                placeholder="جستجو"
                className="my-requstes-filter-item w-100"
                id="search"
              />
            </div>
            <div className="col-1 p-1">
              <button
                className="btn p-1 px-md-2"
                style={{ backgroundColor: "#EF971C", color: "#FFF" }}
                onClick={() => {
                  searchUser();
                }}
              >
                <FaSearch />
              </button>
            </div>
          </div>

          <div className="mt-4 admin-experts-tabel-box p-2 p-lg-4">
            <div
              className="table-responsive p-0"
              style={{ border: "1px solid #fff", borderRadius: "20px" }}
            >
              <table
                className="table table-bordered text-center"
                style={{ borderRadius: "20px" }}
              >
                <thead>
                  <tr style={{ color: "#000" }}>
                    <th scope="col">آیدی</th>
                    <th scope="col">تصویر کاربری</th>
                    <th scope="col">نام کاربر</th>
                    <th scope="col">شماره تماس</th>
                    <th scope="col">کد تایید</th>
                    <th scope="col">وضعیت</th>
                    <th scope="col">پلتفرم</th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((i, index) => (
                    <tr key={index} style={{ color: "#000" }}>
                      <td>{index + 1}</td>
                      <td>
                        {i.pic ? (
                          <img
                            alt=""
                            width={60}
                            height={60}
                            src={`${downloadUrl}${i.pic}`}
                          />
                        ) : (
                          <img
                          alt=""
                          width={60}
                          height={60}
                          src={user}
                        />
                        )}
                      </td>
                      <td
                        onClick={() => {
                          navigate(`${i.id}`, { state: i });
                        }}
                        style={{cursor:"pointer"}}
                      >
                        {i.name}
                      </td>
                      <td>{i.mobile}</td>
                      <td>{i.verifyCode}</td>
                      <td>{i.isActive ? "فعال" : "غیر فعال"}</td>
                      <td>سایت</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div
            className="d-flex w-100 flex-column"
            style={{ cursor: "pointer" }}
          >
            {totalPage === 1 ? null : totalPage === 2 ? (
              <div className="align-self-center">
                <nav aria-label="Page navigation example ">
                  <ul className="pagination">
                    <li className="page-item">
                      <p
                        className="page-link"
                        onClick={() => {
                          pagechanging(1);
                        }}
                      >
                        1
                      </p>
                    </li>
                    <li className="page-item">
                      <p
                        className="page-link"
                        onClick={() => {
                          pagechanging(2);
                        }}
                      >
                        2
                      </p>
                    </li>
                  </ul>
                </nav>
              </div>
            ) : totalPage > 2 ? (
              <div className="align-self-center">
                <nav aria-label="Page navigation example">
                  <ul className="pagination">
                    <li className="page-item">
                      <p
                        className="page-link"
                        aria-label="Previous"
                        onClick={() => {
                          prevpage();
                        }}
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </p>
                    </li>
                    <li className="page-item">
                      <p
                        className="page-link"
                        onClick={() => {
                          pagechanging(1);
                        }}
                      >
                        1
                      </p>
                    </li>
                    <li className="page-item">
                      <p
                        className="page-link"
                        onClick={() => {
                          pagechanging(2);
                        }}
                      >
                        2
                      </p>
                    </li>
                    <li className="page-item">
                      <p
                        className="page-link"
                        onClick={() => {
                          pagechanging(3);
                        }}
                      >
                        3
                      </p>
                    </li>
                    <li>
                      <p
                        className="page-link"
                        aria-label="Next"
                        onClick={() => {
                          nextpage();
                        }}
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </p>
                    </li>
                  </ul>
                </nav>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;
